module.exports = __webpack_public_path__ + "static/img/motorbike-green.89bb022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-green.svg
// module id = gH3H
// module chunks = 74